import React, { useState, useEffect } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import MenuItem from '@mui/material/MenuItem';
import { InputAdornment } from '@mui/material';
import { getLocalNumberLength, getPartner } from '../../../../../lib/access.es6';
import { RELATIONSHIP_POOL } from "../../../../../containers/NewProductList/PoductConstants";
import _ from "lodash";
import { getPartnerGuid } from "../../../../../lib/access.es6";

const ClaimLoggingDetails = (props) => {
  console.log("claim logging details props", props)
  const classes = useStyle();
  const [name, setName] = useState(props.claimState.claimant_full_name || '');
  const [phoneNumber, setPhoneNumber] = useState(props.claimState.claimant_phone_number || '');
  const [idNumber, setIdNumber] = useState(props.claimState.claimant_id_number || '');
  const [relationship, setRelationship] = useState(props.claimState.claimant_relationship_to_patient || null);
  const [member, setMember] = useState("");
  const [members , setMembers] = useState([]);
  const [email, setEmail] = useState(props.claimState.claimant_email || '');
  const [paymentOption, setPaymentOption] = useState(props.claimState.claimant_payment_option || '');
  const [bankName, setBankName] = useState(props.claimState.claimant_bank_name || '');
  const [bankBranch, setBankBranch] = useState(props.claimState.claimant_bank_branch || '');
  const [accountNumber, setAccountNumber] = useState(props.claimState.claimant_bank_account_number || '');
  const [mobileMoneyNumber, setMobileMoneyNumber] = useState(props.claimState.claimant_mobile_money_number || '');
  const [omangNumber, setOmangNumber] = useState(props.claimState.claimant_omang_number || '');
  const partnerGuid = getPartnerGuid();

  // Payment method configurations
  const paymentMethods = {
    "Bank": {
      fields: ["bankName", "bankBranch", "accountNumber"]
    },
    "Orange Money": {
      fields: ["mobileMoneyNumber"]
    },
    "Myzaka": {
      fields: ["mobileMoneyNumber"]
    },
    "Smega": {
      fields: ["mobileMoneyNumber", "omangNumber"]
    }
  };

  const isMobileMoneyPayment = (option) => ["Orange Money", "Myzaka", "Smega"].includes(option);
  const isBankPayment = (option) => option === "Bank";

  useEffect(() => {
    const initialMembers = props.eventQuote ? props.eventQuote.policy_schedule_entries || [] : [];
      if(props.nextOfKin && props.nextOfKin.first_name && props.nextOfKin.relationship_to_patient){
      initialMembers.unshift({
        dependant: {
          first_name: props.nextOfKin.first_name,
          last_name: props.nextOfKin.last_name || '',
          national_id: props.nextOfKin.id_number || '',
          relationship: props.nextOfKin.relationship_to_patient || 'Principal',
          msisdn: props.nextOfKin.phone_number ?  props.nextOfKin.phone_number : '',
        }
      });
    }
    setMembers(initialMembers);
  }, [props.eventQuote.policy_schedule_entries]);

  const internationalCallingCode = getPartner().country
    .international_calling_code;

  // Function to clear payment-related fields
  const clearPaymentFields = () => {
    setBankName('');
    setBankBranch('');
    setAccountNumber('');
    setMobileMoneyNumber('');
    setOmangNumber('');
    
    // Clear in parent state
    props.setAdditionalState("claimant_bank_name", '');
    props.setAdditionalState("claimant_bank_branch", '');
    props.setAdditionalState("claimant_bank_account_number", '');
    props.setAdditionalState("claimant_mobile_money_number", '');
    props.setAdditionalState("claimant_omang_number", '');
  };

  const handlePaymentOptionChange = (value) => {
    setPaymentOption(value);
    props.setAdditionalState("claimant_payment_option", value);
    clearPaymentFields();
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.headingclaim}>
            <h4>Claimant details?</h4>
          </div>
        </Grid>
      </Grid>
      <ValidatorForm onSubmit={() => {}}>
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>
          <Grid item xs={12}>
            <SelectValidator
              labelId="select-member"
              id="select-member"
              value={member}
              name="selectmember"
              type="text"
              label="Select from policy member"
              onChange={(e) => {
                const fullPhoneNumber = e.target.value.dependant.msisdn;
                const n =
                  e.target.value.dependant.first_name +
                  " " +
                  e.target.value.dependant.last_name;
                const i = e.target.value.dependant.national_id;
                const r =
                  e.target.value.dependant.relationship === "Principal"
                    ? "Self"
                    : e.target.value.dependant.relationship;

                setMember(e.target.value);
                setName(
                  e.target.value.dependant.first_name +
                    " " +
                    e.target.value.dependant.last_name
                );
                setIdNumber(e.target.value.dependant.national_id);

                props.setAdditionalState("claimant_full_name", n);

                const nineDigit =
                  fullPhoneNumber &&
                  fullPhoneNumber.substring(5, fullPhoneNumber.length);

                props.setAdditionalState("claimant_phone_number", nineDigit);
                setPhoneNumber(nineDigit);

                props.setAdditionalState("claimant_id_number", i);
                props.setAdditionalState("claimant_relationship_to_patient", r);
                setRelationship(r);
              }}
              variant="outlined"
              validators={["required"]}
              errorMessages={["Please select a member"]}
              style={{ width: "100%" }}
              sx={{
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "0.005em",
                color: "#000000",
              }}
            >
              {members.map((entry, index) => (
                <MenuItem
                  key={index}
                  sx={{
                    fontFamily: "Open Sans",
                    fontStyle: "normal",
                    fontWeight: 300,
                    fontSize: "12px",
                    lineHeight: "16px",
                    letterSpacing: "0.005em",
                    color: "#000000",
                  }}
                  value={entry}
                >
                  {entry.dependant.first_name + " " + entry.dependant.last_name}
                </MenuItem>
              ))}
            </SelectValidator>
            <hr />
          </Grid>

          <Grid item xs={12} md={6} sm={6}>
            <TextValidator
              id="name"
              style={{ width: "100%" }}
              label="Full Names"
              name="name"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                props.setAdditionalState("claimant_full_name", e.target.value);
              }}
              variant="outlined"
              validators={["required"]}
              errorMessages={["Please enter you full names"]}
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextValidator
              id="phone"
              style={{ width: "100%" }}
              label="Phone"
              name="phone"
              value={phoneNumber}
              onChange={(e) => {
                setPhoneNumber(e.target.value);
                props.setAdditionalState(
                  "claimant_phone_number",
                  "00254" + e.target.value
                );
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    sx={{
                      fontSize: "small",
                      color: "#000",
                      background: "#F7F7F7",
                    }}
                    position="start"
                  >
                    {" "}
                    <span
                      style={{
                        fontSize: "small",
                        color: "#000",
                      }}
                    >
                      {internationalCallingCode ? internationalCallingCode : ""}
                    </span>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              validators={["isValidPhoneNumber"]}
              errorMessages={[
                `Please enter a valid ${getLocalNumberLength()} digit phone number`,
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} sm={6}>
            <TextValidator
              id="id"
              style={{ width: "100%" }}
              label="Id number"
              name="id"
              value={idNumber}
              onChange={(e) => {
                setIdNumber(e.target.value);
                props.setAdditionalState("claimant_id_number", e.target.value);
              }}
              variant="outlined"
              validators={["required"]}
              errorMessages={["Please enter you id number"]}
            />
          </Grid>
          
            <Grid item xs={12} md={6} sm={6}>
              <TextValidator
                id="email"
                style={{ width: "100%" }}
                label="Email"
                name="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  props.setAdditionalState("claimant_email", e.target.value);
                }}
                variant="outlined"
                validators={["required"]}
                errorMessages={["Please enter you claimant email"]}
              />
            </Grid>
          
          <Grid item xs={12} md={6} sm={6}>
            <SelectValidator
              labelId="select-relationship"
              id="select-relationship"
              value={relationship}
              label="Relationship"
              name="relationships"
              onChange={(event) => {
                setRelationship(event.target.value);
                props.setAdditionalState(
                  "claimant_relationship_to_patient",
                  event.target.value
                );
              }}
              style={{ width: "100%" }}
              sx={{
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "0.005em",
                color: "#000000",
              }}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please select a relationship']}
              InputLabelProps={{
                shrink: !!relationship,
              }}
            >
              {Object.entries(RELATIONSHIP_POOL)
                .sort(([, vA], [, vB]) => vA.localeCompare(vB))
                .map(([key, value]) => {
                  return (
                    <MenuItem
                      key={value}
                      sx={{
                        fontFamily: "Open Sans",
                        fontStyle: "normal",
                        fontWeight: 300,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0.005em",
                        color: "#000000",
                      }}
                      //disabled={principalAdded}
                      value={key}
                    >
                      {_.startCase(key)}
                    </MenuItem>
                  );
                })}
            </SelectValidator>
          </Grid>
          {(partnerGuid === "omk" || partnerGuid === "cover_link") && !props.isLegalCover && (
            <Grid item xs={12} sm={6} md={6}>
              <SelectValidator
                labelId="payment-option"
                id="payment-option"
                value={paymentOption}
                name="paymentOption"
                type="text"
                label="Select Payment Option"
                onChange={(e) => {
                  handlePaymentOptionChange(e.target.value);
                }}
                variant="outlined"
                validators={["required"]}
                errorMessages={["Please select a payment option"]}
                style={{ width: "100%" }}
                sx={{
                  fontFamily: "Open Sans",
                  fontStyle: "normal",
                  fontWeight: 300,
                  fontSize: "12px",
                  lineHeight: "16px",
                  letterSpacing: "0.005em",
                  color: "#000000",
                }}
              >
                {Object.keys(paymentMethods).map((option, index) => (
                  <MenuItem
                    key={index}
                    sx={{
                      fontFamily: "Open Sans",
                      fontStyle: "normal",
                      fontWeight: 300,
                      fontSize: "12px",
                      lineHeight: "16px",
                      letterSpacing: "0.005em",
                      color: "#000000",
                    }}
                    value={option}
                  >
                    {option}
                  </MenuItem>
                ))}
              </SelectValidator>
            </Grid>
          )}
          {/* Bank Payment Fields */}
          {isBankPayment(paymentOption) && (
            <>
              <Grid item xs={12} md={6} sm={6}>
                <TextValidator
                  id="bank-name"
                  style={{ width: "100%" }}
                  label="Bank Name"
                  name="bankName"
                  value={bankName}
                  onChange={(e) => {
                    setBankName(e.target.value);
                    props.setAdditionalState("claimant_bank_name", e.target.value);
                  }}
                  variant="outlined"
                  validators={["required"]}
                  errorMessages={["Please enter a bank name"]}
                />
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <TextValidator
                  id="bank-branch"
                  style={{ width: "100%" }}
                  label="Bank Branch"
                  name="bankBranch"
                  value={bankBranch}
                  onChange={(e) => {
                    setBankBranch(e.target.value);
                    props.setAdditionalState("claimant_bank_branch", e.target.value);
                  }}
                  variant="outlined"
                  validators={["required"]}
                  errorMessages={["Please enter a bank branch"]}
                />
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <TextValidator
                  id="account-number"
                  style={{ width: "100%" }}
                  label="Account Number"
                  name="accountNumber"
                  value={accountNumber}
                  onChange={(e) => {
                    setAccountNumber(e.target.value);
                    props.setAdditionalState("claimant_bank_account_number", e.target.value);
                  }}
                  variant="outlined"
                  type="number"
                  validators={["required", "isNumber", "minNumber:0"]}
                  errorMessages={["Please enter a valid account number"]}
                />
              </Grid>
            </>
          )}

          {/* Mobile Money Payment Fields */}
          {isMobileMoneyPayment(paymentOption) && (
            <Grid item xs={12} md={6} sm={6}>
              <TextValidator
                id="mobile-money-number"
                style={{ width: "100%" }}
                label={paymentOption === "Smega" ? "Phone Number" : "Mobile Money Number"}
                name="mobileMoneyNumber"
                value={mobileMoneyNumber}
                onChange={(e) => {
                  setMobileMoneyNumber(e.target.value);
                  props.setAdditionalState("claimant_mobile_money_number", e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      sx={{
                        fontSize: "small",
                        color: "#000",
                        background: "#F7F7F7",
                      }}
                      position="start"
                    >
                      <span style={{ fontSize: "small", color: "#000" }}>
                        {internationalCallingCode || ""}
                      </span>
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
                validators={["required", "isValidPhoneNumber"]}
                errorMessages={[
                  `Please enter a valid ${getLocalNumberLength()} digit ${
                    paymentOption === "Smega" ? "phone number" : "mobile money number"
                  }`,
                ]}
              />
            </Grid>
          )}

          {/* Omang Number Field (Smega only) */}
          {paymentOption === "Smega" && (
            <Grid item xs={12} md={6} sm={6}>
              <TextValidator
                id="omang-number"
                style={{ width: "100%" }}
                label="Omang Number"
                name="omangNumber"
                value={omangNumber}
                onChange={(e) => {
                  setOmangNumber(e.target.value);
                  props.setAdditionalState("claimant_omang_number", e.target.value);
                }}
                variant="outlined"
                validators={["required"]}
                errorMessages={["Please enter your Omang number"]}
              />
            </Grid>
          )}

          
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default ClaimLoggingDetails